/* Finder Window */
.finder {
  position: absolute;
  background: var(--color-surface);
  border: var(--border-medium) var(--border-style) var(--color-border-strong);
  border-radius: var(--radius-window);
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  will-change: transform;
  display: flex;
  flex-direction: column;
  animation: windowOpen 0.3s ease-out;
  transform-origin: center center;
}

.finder.dragging {
  cursor: grabbing;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
}

.finder.maximized {
  border-radius: 0;
}

@keyframes windowOpen {
  from {
    opacity: 0;
    scale: 0.95;
  }
  to {
    opacity: 1;
    scale: 1;
  }
}

.finder.closing {
  animation: windowClose 0.2s ease-in forwards;
  pointer-events: none;
}

@keyframes windowClose {
  from {
    opacity: 1;
    scale: 1;
  }
  to {
    opacity: 0;
    scale: 0.95;
  }
}

.finderHeader {
  background: var(--color-surface-raised);
  border-bottom: var(--border-thin) var(--border-style) var(--color-border);
  padding: var(--space-2) var(--space-3);
  display: flex;
  align-items: center;
  gap: var(--space-3);
  cursor: grab;
  user-select: none;
  touch-action: none;
}

.finder.dragging .finderHeader {
  cursor: grabbing;
}

.finderTitle {
  font-family: var(--font-mono);
  font-size: var(--caption-size);
  color: var(--color-text-muted);
  margin-left: auto;
}

.finderToolbar {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  background: var(--color-surface-sunken);
  border-bottom: var(--border-thin) var(--border-style) var(--color-border);
}

.finderNavButton {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface);
  border: var(--border-thin) var(--border-style) var(--color-border);
  border-radius: var(--radius-xs);
  font-size: 10px;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
}

.finderNavButton:hover:not(:disabled) {
  background: var(--color-surface-raised);
  color: var(--color-text);
}

.finderNavButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.finderPathBar {
  flex: 1;
  font-family: var(--font-mono);
  font-size: var(--caption-size);
  color: var(--color-text-muted);
  padding: var(--space-1) var(--space-2);
  background: var(--color-surface);
  border: var(--border-thin) var(--border-style) var(--color-border);
  border-radius: var(--radius-xs);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.finderBody {
  flex: 1;
  overflow: auto;
  padding: var(--space-3);
}

.finderEmpty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: var(--font-mono);
  font-size: var(--caption-size);
  color: var(--color-text-subtle);
}

.finderGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: var(--space-3);
}

.finderItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-2);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background var(--transition-fast);
}

.finderItem:hover {
  background: var(--color-surface-sunken);
}

.finderItem.selected {
  background: var(--color-accent-primary);
}

.finderItem.selected .finderItemName {
  color: white;
}

.finderItemIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: var(--color-text);
}

.finderItemIcon svg {
  width: 100%;
  height: 100%;
}

.finderItemName {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text);
  text-align: center;
  word-break: break-all;
  line-height: 1.3;
  max-width: 100%;
}

.finderStatusBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-1) var(--space-3);
  background: var(--color-surface-sunken);
  border-top: var(--border-thin) var(--border-style) var(--color-border);
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-subtle);
}
